export default "__VITE_ASSET__CdcdG6vz__"